import React from "react";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Text } from "@chakra-ui/react";
export default function ArchivedAccountDetails({ record, onClose }: {record: any; onClose: () => void}) {
  return <Modal isOpen={Boolean(record)} onClose={onClose}><ModalOverlay /><ModalContent>
    <ModalHeader>Deleted account record</ModalHeader><ModalCloseButton /><ModalBody pb={6}>
      {record && <>{Object.entries({Name: record.businessName || [record.firstName, record.lastName].filter(Boolean).join(" "),
        Email: record.email, Phone: record.phoneNumber, Address: record.address,
        State: record.state, "Date of birth": record.dob, Role: record.accountType,
        "Deleted at": record.deletedAt, "Account ID": record._id}).map(([label, value]) =>
          <Text key={label} mb={2}><strong>{label}:</strong> {String(value || "Not recorded")}</Text>)}</>}
    </ModalBody></ModalContent></Modal>;
}
